// angle returns the angle in radians between the point [0, 0] and pt, where
// angle([0, x]) returns 0 for negative x, and pi for positive x.
function angle(pt) {
  let out = Math.atan(-pt[1] / pt[0])
  out = Math.PI/2 - out

  if (pt[0] < 0) {
    out += Math.PI
  }

  return out
}

// labelWillFit is a heuristic method to determine if a label on a pie chart
// will fit between the two rays from the center of the pie. centroid is the
// point [x, y] where the center of the label goes, d is data about the slice.
export function labelWillFit(centroid, d) {
  // We assume that the label is two lines, each centered, and that each line is
  // 30px high with characters that are 7px wide.

  let labelLen = 8 * d.data.name.length,
    percentLen = 8 * 4

  let pts = [
    [centroid[0] - (labelLen/2), centroid[1] + 15], // Corners of label text box.
    [centroid[0] + (labelLen/2), centroid[1] + 15],
    [centroid[0] - (labelLen/2), centroid[1] - 15],
    [centroid[0] + (labelLen/2), centroid[1] - 15],
    [centroid[0] - (percentLen/2), centroid[1] - 15], // Corners of percent text box.
    [centroid[0] + (percentLen/2), centroid[1] - 15],
    [centroid[0] - (percentLen/2), centroid[1] - 30],
    [centroid[0] + (percentLen/2), centroid[1] - 30],
  ]

  // There are two rays from the origin of the pie graph. All points should be
  // between these two rays.
  for (let i = 0; i < pts.length; i++) {
    let theta = angle(pts[i])
    if (theta < d.startAngle || theta > d.endAngle) {
      return false
    }
  }

  return true
}

function findPreceding(i, data0, data1, key) {
  let m = data0.length
  while (--i >= 0) {
    let k = key(data1[i])
    for (let j = 0; j < m; ++j) {
      if (key(data0[j]) === k) return data0[j]
    }
  }
}

function findFollowing(i, data0, data1, key) {
  let n = data1.length, m = data0.length;
  while (++i < n) {
    let k = key(data1[i])
    for (let j = 0; j < m; ++j) {
      if (key(data0[j]) === k) return data0[j]
    }
  }
}

// findArcEntry assumes that data0 has already been drawn and that we're moving
// to data1, where data1[i] is a new data point. It returns the location where
// the slice for data1[i] should "bloom" from.
export function findArcEntry(i, data0, data1, key) {
  if (data0.length == 0) {
    return null
  }
  let d = findPreceding(i, data0, data1, key)
  if (d) {
    return {startAngle: d.endAngle, endAngle: d.endAngle}
  }
  return {startAngle: 0, endAngle: 0}
}

// findArcExit assumes that data0 has already been drawn and that we're moving
// to data1, where data0[i] is a data point which was completely removed from
// data1. It returns the location where the slice for data0[i] should "collapse"
// to before being deleted.
export function findArcExit(i, data0, data1, key) {
  let d = findFollowing(i, data1, data0, key)
  if (d) {
    return {startAngle: d.startAngle, endAngle: d.startAngle}
  }
  return {startAngle: 2*Math.PI, endAngle: 2*Math.PI}
}

// findBlockEntry is findArcEntry for a CompGraph.
export function findBlockEntry(i, data0, data1, key) {
  if (data0.length == 0) {
    return null
  }
  let d = findPreceding(i, data0, data1, key)
  if (d) {
    return {start: d.end, end: d.end}
  }
  return {start: 0, end: 0}
}

// findBlockExit is findBlockExit for a CompGraph.
export function findBlockExit(i, data0, data1, key) {
  let d = findFollowing(i, data1, data0, key)
  if (d) {
    return {start: d.start, end: d.start}
  }
  return {start: 1, end: 1}
}



// WEBPACK FOOTER //
// ./src/components/mixins/geometry.js